import React, { useContext } from 'react'
import { observer } from 'mobx-react'
import { useNavigate } from 'react-router'
import day from 'dayjs'
import { StoresContext } from '@App/contexts'
import Navigation from '@App/navigation'
import Button from '@Components/Buttons/Button'
import { WorkModel } from '@Entities/work/work'
import WorkMergeRequestGroup from '@Scenes/RightsholderScene/WorkMerge/WorkMergeRequestGroup'
import WorkMergeRequestPage from '@Scenes/RightsholderScene/WorkMerge/WorkMergeRequestPage'
import WorkMergeStatusPill from '@Scenes/RightsholderScene/WorkMerge/WorkMergeStatusPill'
import './index.scss'

const WorkMergeRequestDetail = () => {
    const { workMergeRequestDetailStore, rightsholderStore } = useContext(StoresContext)
    const navigate = useNavigate()

    const goToMyRequests = () =>
        navigate(Navigation.rightholder.workMerge.myMergeRequests(rightsholderStore.currentRightsholderId))

    return (
        <WorkMergeRequestPage store={workMergeRequestDetailStore} className="work-merge-request-detail">
            {(request) => {
                const primaryWork = request.primaryWork.work
                const secondaryWorks = request.secondaryWorks
                    .map((requestWork) => requestWork.work)
                    .filter((work): work is WorkModel => work != null)

                return (
                    <>
                        <div className="work-merge-request-detail-header">
                            <h5>Merge Request Details</h5>
                            <p>The information below reflects the details of the merge request you submitted.</p>
                        </div>

                        <div className="work-merge-request-detail-meta">
                            <p>
                                Submitted by <strong>{request.submittedBy}</strong> on{' '}
                                <strong>{day(request.submittedAt).format('MMMM D, YYYY')}</strong>
                            </p>
                            <WorkMergeStatusPill status={request.status} />
                        </div>

                        {primaryWork ? (
                            <WorkMergeRequestGroup
                                heading="Merge Request"
                                primaryWork={primaryWork}
                                secondaryWorks={secondaryWorks}
                                reason={request.reason}
                            />
                        ) : (
                            <p className="work-merge-request-page-empty">
                                {request.primaryWork.title} ({request.primaryWork.songCode})
                            </p>
                        )}

                        <div className="work-merge-request-page-footer">
                            <Button type="secondary" mainColor onClick={goToMyRequests}>
                                Back
                            </Button>
                        </div>
                    </>
                )
            }}
        </WorkMergeRequestPage>
    )
}

export default observer(WorkMergeRequestDetail)
